<template lang="pug">
	div
</template>

<script>
import Vue from 'vue'

export default {
	name: 'Logout',
	beforeCreate () {
		Vue.e24.security.logout().then((resp) => {
			this.$router.push({name: 'connect', params: {goodbye: 'TRUE'}})
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/logout-component.vue